<template>
    <div class="flex-level">
        <div class="ellipsis search-result-item gray-100">
            <span>#{{ data.id }}</span>
        </div>
        <div class="ellipsis search-result-item ml-2 gray-60">
            <chip-label :color="data.status.color" :label="data.status.label" />
        </div>
        <div class="ellipsis search-result-item ml-2 gray-60">
            <span>{{ data.third }}</span>
        </div>
        <div class="ellipsis search-result-item ml-2 gray-60">
            <span>{{ data.subject }}</span>
        </div>
        <div v-if="data.link" class="flex-right"><i class="icon-chevron-right gray-60"></i></div>
    </div>
</template>

<script>
import ChipLabel from 'vcomponents/utilities/ChipLabel.vue';
export default {
    components: {
        ChipLabel,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
};
</script>
